import React, { useState } from 'react';
import './CustomerPriceRange.css';
import { elakayAutoText } from './dataElakay';

const CUSTOMER_PRICE_MIN = 0;
const CUSTOMER_PRICE_MAX = 4000;

// Filtre "Customer Price" — range slider libre (min/max en dollars), en plus
// des paliers de prix prédéfinis (RadioBox). handleFilters reçoit directement
// [min, max] ; voir handlePrice() dans productCatalog.js/resultsSearch.js/
// userProduct.js qui détecte un tableau et l'utilise tel quel (pas de lookup
// par _id de palier).
const CustomerPriceRange = ({ handleFilters, min = CUSTOMER_PRICE_MIN, max = CUSTOMER_PRICE_MAX, label: labelOverride }) => {
  const [range, setRange] = useState([min, max]);

  const applyRange = (nextRange) => {
    setRange(nextRange);
    handleFilters(nextRange);
  };

  const minPercent = ((range[0] - min) / (max - min)) * 100;
  const maxPercent = ((range[1] - min) / (max - min)) * 100;
  const label = labelOverride || elakayAutoText('h_customer_price_label', 'Customer Price');

  return (
    <div className="customer-price-range">
      <div className="customer-price-range-header">
        <span className="customer-price-range-label">{label}</span>
        <span className="customer-price-range-values">${range[0]} - ${range[1]}</span>
      </div>
      <div className="customer-price-range-track-wrapper">
        <div className="customer-price-range-track" />
        <div
          className="customer-price-range-track-active"
          style={{ left: `${minPercent}%`, right: `${100 - maxPercent}%` }}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={range[0]}
          onChange={(e) => {
            const next = Math.min(Number(e.target.value), range[1]);
            applyRange([next, range[1]]);
          }}
          className="customer-price-range-input"
          aria-label={elakayAutoText("h_b6f26bcbce1a27", "{value0} minimum", { value0: label })}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={range[1]}
          onChange={(e) => {
            const next = Math.max(Number(e.target.value), range[0]);
            applyRange([range[0], next]);
          }}
          className="customer-price-range-input"
          aria-label={elakayAutoText("h_4e87658d2e1335", "{value0} maximum", { value0: label })}
        />
      </div>
    </div>
  );
};

export default CustomerPriceRange;
